import { render, staticRenderFns } from "./TipTool.vue?vue&type=template&id=a80004e0&scoped=true"
import script from "./TipTool.vue?vue&type=script&lang=js"
export * from "./TipTool.vue?vue&type=script&lang=js"
import style0 from "./TipTool.vue?vue&type=style&index=0&id=a80004e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80004e0",
  null
  
)

export default component.exports